import * as ActionTypes from "../actions/actionTypes";

const initialState = {
	topics: [],
};

export default function topicsReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.LOAD_TOPICS_SUCCESS:
			return {
				...state,
				topics: action.topics,
			};
		default:
			return state;
	}
}
